import { FIELD_PATHS } from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';
import { validateDateAfter, validateNotFutureDate } from '@funnels/utils';

import { DatePickerInputField } from '../../Fields';

interface EmploymentEndDateProps extends EmploymentEntityIndex {
  startDate?: string;
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const EmploymentEndDate = (props: EmploymentEndDateProps) => {
  const { employmentIndex, startDate, ...rest } = props;

  const validate = (value: string) => {
    return (
      validateDateAfter(startDate, 'Please enter an end date later than the start date', rest.isOptional)(value) ||
      validateNotFutureDate('Please enter an end date which is not in the future', rest.isOptional)(value)
    );
  };

  return (
    <DatePickerInputField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_END_DATE(employmentIndex)}
      label="End date"
      validate={validate}
    />
  );
};
